<!--
 * @Author: lsr lsr@qq.com
 * @Date: 2022-06-23 17:59:46
 * @LastEditors: lsr lsr@qq.com
 * @LastEditTime: 2022-06-23 19:23:07
 * @FilePath: \YHB_H5\src\pages\rysPrivacyPolicy\privacyPolicy.vue
 * @Description: 幸福刷机具使用协议
-->
<template>
    <div class="content">
      <div v-html="content"></div>
    </div>
  </template>
  <script>
  import { rysUserAgreement  } from '@/api/index'
  import { Toast } from 'vant';
  export default {
    data () {
      return {
        title: '',
        content: ''
      }
    },
    created(){
      this.getInformation(96)
    },
    methods: {
      getInformation (typeId) {
        rysUserAgreement(typeId).then(res => {
          if (res.code != 200) {
  
            Toast({
              message: res.msg,
              duration: 3000
            });
  
            return;
  
  
          }
          this.title = res.data.title;
          this.content = res.data.content
        })
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  .content{
    padding:30px;
    line-height: 1.8;
    pre{
            white-space: pre-line;
    }
  }
  
  </style>